module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qresp7-ee5d8f01ba842844b3f0d9d920d8e609.jpg";